import React from 'react';
import classNames from 'classnames';
import type { AnalysisGroup, Dimension } from '../../types';
import styles from './index.module.scss';

interface LevelSidebarProps {
  groups: AnalysisGroup[];
  activeDimension?: Dimension;
  onChange: (value: Dimension) => void;
}

const LevelSidebar: React.FC<LevelSidebarProps> = ({ groups, activeDimension, onChange }) => (
  <div className={styles.sidebar}>
    <div className={styles.label}>统计层级</div>
    <div className={styles.list}>
      {groups.map(group => (
        <div
          key={group.key}
          className={classNames(styles.item, activeDimension === group.key && styles.active)}
          onClick={() => onChange(group.key)}
        >
          <img src={group.icon} alt="" />
          <span className={styles.groupInfo}>
            <span className={styles.groupName}>{group.name}</span>
            <span className={styles.groupDescription}>{group.description}</span>
          </span>
          <span className={styles.groupCount}>{group.count}</span>
          <span className={styles.groupUnit}>个</span>
        </div>
      ))}
    </div>
  </div>
);

export default LevelSidebar;
